import React from "react";

const UserPlaceholder = () => {
  return (
    <svg
      width="100"
      height="92"
      viewBox="0 0 100 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3433_1171"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="100"
        height="92"
      >
        <rect width="100" height="91.195" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3433_1171)">
        <path
          d="M50.0499 44.4724C46.0276 44.4724 42.5914 43.1729 39.7415 40.574C36.8916 37.9751 35.4667 34.8415 35.4667 31.1733C35.4667 27.5051 36.8916 24.3715 39.7415 21.7725C42.5914 19.1736 46.0276 17.8741 50.0499 17.8741C54.0723 17.8741 57.5084 19.1736 60.3584 21.7725C63.2082 24.3715 64.6332 27.5051 64.6332 31.1733C64.6332 34.8415 63.2082 37.9751 60.3584 40.574C57.5084 43.1729 54.0723 44.4724 50.0499 44.4724ZM18.8 67.6366V64.9621C18.8 63.1012 19.3543 61.378 20.4628 59.7923C21.5712 58.2066 23.0522 56.9875 24.9058 56.135C29.0244 54.2936 33.179 52.9125 37.3697 51.9918C41.5604 51.0711 45.7872 50.6108 50.0499 50.6108C54.3127 50.6108 58.5395 51.0711 62.7301 51.9918C66.9208 52.9125 71.0755 54.2936 75.1941 56.135C77.0477 56.9875 78.5287 58.2066 79.6371 59.7923C80.7456 61.378 81.2998 63.1012 81.2998 64.9621V67.6366C81.2998 69.2393 80.6842 70.602 79.4529 71.7249C78.2216 72.8478 76.7273 73.4092 74.9698 73.4092H25.13C23.3726 73.4092 21.8783 72.8478 20.647 71.7249C19.4157 70.602 18.8 69.2393 18.8 67.6366Z"
          fill="#8692A8"
        />
      </g>
    </svg>
  );
};

export default UserPlaceholder;
